import { getRequest, putRequest } from 'utils/http'

export const getPLP = () => {
  return getRequest('/personality')
}

export const editSteps = payload => {
  return putRequest('/personality', payload)
}
